import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
const RegionCampaignHeatmap: React.FC = () => {
  const regionData = [{
    region: 'West',
    effectiveness: 89,
    spend: 125.4,
    leads: 28500,
    conversions: 4850,
    roi: 312
  }, {
    region: 'North',
    effectiveness: 85,
    spend: 108.2,
    leads: 24200,
    conversions: 4125,
    roi: 285
  }, {
    region: 'South',
    effectiveness: 78,
    spend: 95.8,
    leads: 19800,
    conversions: 3420,
    roi: 248
  }, {
    region: 'East',
    effectiveness: 72,
    spend: 74.5,
    leads: 15200,
    conversions: 2640,
    roi: 215
  }];
  const getEffectivenessColor = (effectiveness: number) => {
    if (effectiveness >= 85) return '#10b981';
    if (effectiveness >= 75) return '#f59e0b';
    return '#ef4444';
  };
  return <Card className="p-6 mb-8" data-id="element-7955">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7956">
        Region-wise Campaign Impact
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7957">
        Campaign effectiveness and performance by region
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-7958">
        {/* Effectiveness Bar Chart */}
        <div data-id="element-7959">
          <h4 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-7960">
            Effectiveness Score by Region
          </h4>
          <ResponsiveContainer width="100%" height={300} data-id="element-7961">
            <BarChart data={regionData} data-id="element-7962">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7963" />
              <XAxis dataKey="region" tick={{
              fontSize: 12
            }} data-id="element-7964" />
              <YAxis tick={{
              fontSize: 12
            }} domain={[0, 100]} data-id="element-7965" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} data-id="element-7966" />
              <Bar dataKey="effectiveness" name="Effectiveness %" data-id="element-7967">
                {regionData.map((entry, index) => <Cell key={`cell-${index}`} fill={getEffectivenessColor(entry.effectiveness)} data-id="element-7968" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        {/* Regional Performance Cards */}
        <div className="space-y-3" data-id="element-7969">
          <h4 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-7970">
            Regional Performance Metrics
          </h4>
          {regionData.map((region, index) => <div key={index} className="p-4 bg-gradient-to-r from-gray-50 to-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow" data-id="element-7971">
              <div className="flex items-center justify-between mb-2" data-id="element-7972">
                <div className="flex items-center" data-id="element-7973">
                  <div className="w-3 h-3 rounded-full mr-2" style={{
                backgroundColor: getEffectivenessColor(region.effectiveness)
              }} data-id="element-7974" />
                  <span className="font-bold text-gray-900" data-id="element-7975">
                    {region.region}
                  </span>
                </div>
                <span className="text-sm font-bold text-gray-900" data-id="element-7976">
                  {region.effectiveness}% effective
                </span>
              </div>
              <div className="grid grid-cols-4 gap-2 text-xs" data-id="element-7977">
                <div data-id="element-7978">
                  <div className="text-gray-500" data-id="element-7979">Spend</div>
                  <div className="font-semibold text-gray-800" data-id="element-7980">
                    ₹{region.spend}L
                  </div>
                </div>
                <div data-id="element-7981">
                  <div className="text-gray-500" data-id="element-7982">Leads</div>
                  <div className="font-semibold text-gray-800" data-id="element-7983">
                    {(region.leads / 1000).toFixed(1)}K
                  </div>
                </div>
                <div data-id="element-7984">
                  <div className="text-gray-500" data-id="element-7985">Conversions</div>
                  <div className="font-semibold text-gray-800" data-id="element-7986">
                    {(region.conversions / 1000).toFixed(1)}K
                  </div>
                </div>
                <div data-id="element-7987">
                  <div className="text-gray-500" data-id="element-7988">ROI</div>
                  <div className="font-semibold text-green-600" data-id="element-7989">
                    {region.roi}%
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7990">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-7991">
          <div className="text-center" data-id="element-7992">
            <div className="text-gray-600" data-id="element-7993">Total Spend</div>
            <div className="text-xl font-bold text-gray-900" data-id="element-7994">₹403.9L</div>
          </div>
          <div className="text-center" data-id="element-7995">
            <div className="text-gray-600" data-id="element-7996">Total Leads</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-7997">87.7K</div>
          </div>
          <div className="text-center" data-id="element-7998">
            <div className="text-gray-600" data-id="element-7999">Total Conversions</div>
            <div className="text-xl font-bold text-green-600" data-id="element-8000">15.0K</div>
          </div>
          <div className="text-center" data-id="element-8001">
            <div className="text-gray-600" data-id="element-8002">Avg Effectiveness</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-8003">81%</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default RegionCampaignHeatmap;